function CookiePage() {
  function getSubmitButton(): HTMLButtonElement | null {
    return document.querySelector<HTMLButtonElement>(`button[data-cookie-action="saveChoices"]`);
  }

  function setCheckboxesChecked(checked: boolean) {
    const checkboxes = document.querySelectorAll<HTMLInputElement>(`input[type="checkbox"]:not([required])`);
    checkboxes.forEach((checkbox) => {
      checkbox.checked = checked;
    });
  }

  const cookieDialog: HTMLDialogElement | null = document.querySelector('[data-show-dialog="cookie"]');
  if (cookieDialog) {
    cookieDialog.showModal();
    cookieDialog.focus();
  }

  document.addEventListener("click", (e) => {
    const target = (e.target as HTMLElement)?.closest('button');

    if (!(target instanceof HTMLButtonElement)) {
      return;
    }

    if (target.dataset.cookieAction == "acceptNecessary") {
      setCheckboxesChecked(false);
      getSubmitButton()?.click();
    }

    if (target.dataset.cookieAction == "acceptAll") {
      setCheckboxesChecked(true);
      getSubmitButton()?.click();
    }
  });
}
CookiePage();

export default CookiePage;
